import { useTimezone } from '@app/core/hooks/useTimezone';
import { forceTz } from '@mi-front/core';
import { DateField, TimeField } from '@mi-front/ui';
import { Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';
import { GipReportValues } from '../types';

export const ToField = () => {
  const { $t } = useIntl();
  const {
    values: { to },
    setFieldValue,
  } = useFormikContext<GipReportValues>();
  const tz = useTimezone();

  return (
    <Grid container>
      <Grid item xs={12} md={7}>
        <DateField
          name="to"
          label={$t({
            id: 'audit.gipReport.form.endDate',
            defaultMessage: 'Fecha de fin',
          })}
          max={moment(new Date()).format('YYYY-MM-DD')}
          isOutsideRange={(date) => moment(date) > moment()}
          onChange={(value) => {
            const time = moment(to).tz(tz).format('HH:mm:ss');
            const date = forceTz(`${value} ${time}` as any, tz);

            setFieldValue('to', moment(date).toISOString());
          }}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <TimeField
          name="to_time"
          label={$t({
            id: 'audit.gipReport.form.endTime',
            defaultMessage: 'Hora de fin',
          })}
          value={moment(to).format('HH:mm')}
          onChange={(event) => {
            const [hour, minutes] = event.currentTarget.value.split(':');
            const value = moment(to).hour(Number(hour)).minutes(Number(minutes));

            setFieldValue('to', value.toISOString());
          }}
        />
      </Grid>
    </Grid>
  );
};
